/* Add colour highlighting for primary sort
   The initial primary sort is always Rank, but since that's not the record column we don't want to highlight that.
   Here only the non-rank primary sort or second-to-rank sort is highlighted.
   */
export const getProps = (state, rowInfo, column, instance) => {
    if (state.sorted.length === 0) {
        return {};
    }

    let props = {};
    const isPrimarySortCurrentCol = state.sorted[0].id === column.id;
    const isPrimaryIndex = state.sorted[0].id === 'index';
    const isSecondarySortCurrentCol = state.sorted[1] && state.sorted[1].id === column.id;
    const isSortAfterRank = isPrimaryIndex && isSecondarySortCurrentCol;
    const isPrimarySortPlayerName = state.sorted[0].id === 'name';

    if ((isPrimarySortPlayerName && column.id === 'id') || isPrimarySortCurrentCol || isSortAfterRank) {
        props = {
            style: {
                background: 'rgba(1,131,218,.3)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.02)',
            },
        };
    }

    return props;
};

export default {
    getProps,
};
